// "+ New note" (decision 90 v2): a chooser like the Journal's "New entry", a Sheet on a phone and a
// Modal on desktop. "Blank note" first and highlighted, then the templates, each with a one-line
// description. When the note is started from a client, a project or a task, the chooser says what it
// will be linked to.
import React from 'react';
import { Modal, Sheet, useBreakpoint } from '../../ui';
import './notesBrowse.css';

export default function NewNoteChooser({ open, onClose, templates, onBlank, onTemplate, linkLabel }) {
  const phone = useBreakpoint() === 'phone';
  const body = (
    <div className="nt-choose">
      <p className="nt-choose__lead">
        Start blank, or from a template.{linkLabel ? <> It will be linked to <b>{linkLabel}</b>.</> : null}
      </p>
      <ul className="nt-choose__grid" aria-label="Kinds of note">
        <li>
          <button type="button" className="nt-choose__opt nt-choose__opt--blank" onClick={onBlank} data-testid="nt-new-blank">
            <span className="nt-choose__icon" aria-hidden="true">📝</span>
            <span className="nt-choose__name">Blank note</span>
            <span className="nt-choose__desc">An empty page: a title and whatever you want to write. Type / for headings, to-dos and more.</span>
          </button>
        </li>
        {templates.map((t) => (
          <li key={t.key}>
            <button type="button" className="nt-choose__opt" onClick={() => onTemplate(t)}>
              <span className="nt-choose__icon" aria-hidden="true">{t.emoji}</span>
              <span className="nt-choose__name">{t.title}</span>
              <span className="nt-choose__desc">{t.desc}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
  return phone
    ? <Sheet open={open} onClose={onClose} title="New note" color="pastel-pink">{body}</Sheet>
    : <Modal open={open} onClose={onClose} title="New note" color="pastel-pink" width={760}>{body}</Modal>;
}
